import { uuidV4 as R, getOrCall as f, equalsPrimitive as A, copyPrimitive as E, clonePrimitive as M, recordUndoCommand as V, setValueUndoCommand as w, SimpleEventDispatcher as O, JSUndoManager as F, getUrlQueryParam as P, now as x, timeout as I, createDiv as Q } from "ts-browser-helpers";
import { clonePrimitive as re, copyPrimitive as ne, equalsPrimitive as ie } from "ts-browser-helpers";
/**
 * @license
 * uiconfig.js v0.3.1
 * Copyright 2022-2025 repalash <palash@shaders.app>
 * MIT License
 * See ./dependencies.txt for bundled third-party dependencies and licenses.
 */
const C = class C {
};
C.Map = /* @__PURE__ */ new Map();
let c = C;
function v(n, e, t, r, i = !0) {
  r = r ?? n[e], t = t ?? e + "";
  const o = r == null ? void 0 : r.uiConfig;
  let s;
  if (o)
    s = o;
  else {
    const a = T(r);
    a === "folder" ? s = U(t, r, {}, "folder", i) : a && (s = {
      type: a,
      label: t,
      property: [n, e]
    });
  }
  return s && !s.label && (s.label = t), s;
}
function _(n) {
  if (!n) return [];
  let e = n.constructor || Object;
  e === Array && (e = Object);
  const t = [], r = [];
  for (; e && e !== Object; )
    r.push(e), e = Object.getPrototypeOf(e);
  if (!r.length || Array.isArray(n)) {
    const i = typeof n == "object" ? Object.keys(n) : Array.isArray(n) ? n.map((o, s) => s) : [];
    for (const o of i) {
      const s = n[o];
      if (s == null) continue;
      const a = v(n, o, o + "", s, !0);
      a && t.push(a);
    }
  }
  return r.reverse().forEach((i) => {
    var o;
    (o = c.Map.get(i)) == null || o.forEach(({ params: s, propKey: a, uiType: u }) => {
      let d;
      if (u || (d = () => v(n, a)), d || (d = {
        property: [n, a],
        type: u || "input"
        // ...params,
        // ...extraParams,
      }), s) {
        const y = typeof s.params == "function" ? s.params(n) : s.params || {}, p = { ...s };
        if (delete p.params, typeof d == "function") {
          const m = d;
          d = () => {
            const l = m();
            return l && Object.assign(l, { ...p, ...y });
          };
        } else
          Object.assign(d, { ...p, ...y });
      }
      t.push(d);
    });
  }), t;
}
function U(n, e, t = {}, r = "folder", i = !1) {
  return {
    type: r,
    label: n,
    children: i ? [() => _(e)] : _(e),
    uuid: R(),
    ...t
  };
}
function T(n) {
  return n == null ? null : Array.isArray(n) ? "folder" : typeof n == "boolean" ? "checkbox" : typeof n == "number" ? "number" : typeof n == "string" ? "input" : typeof n == "function" ? "button" : typeof n.x == "number" ? "vec" : typeof n.r == "number" ? "color" : n.isTexture ? "image" : typeof n == "object" ? "folder" : null;
}
function B(n) {
  return (e, t) => {
    const r = e.constructor;
    if (r === Object) throw new Error("Not possible to use uiConfig decorator on an object, use class instead");
    c.Map.has(r) || c.Map.set(r, []), n(e, t, c.Map.get(r));
  };
}
function h(n, e) {
  return B((t, r, i) => {
    const o = i.findIndex((s) => s.propKey === r);
    if (o && o < 0)
      i.push({
        params: e || {},
        propKey: r,
        uiType: n
      });
    else
      throw new Error(`Property ${r} already has a uiConfig decorator`);
  });
}
function b(n, e, t = "panel") {
  return (r) => class extends r {
    constructor() {
      super(...arguments), this.uiConfig = U(f(n, this) || "", this, e || {}, t);
    }
  };
}
function j(n, e) {
  return h("monitor", { label: n, params: e });
}
function q(n, e, t, r) {
  return h("slider", { label: n, bounds: e, stepSize: t, params: r });
}
function D(n, e, t, r) {
  return h("vec", { label: n, bounds: e, stepSize: t, params: r });
}
function N(n, e, t) {
  return Array.isArray(e) && typeof e[0] == "string" && (e = e.map((r) => ({ label: r, value: r }))), h("dropdown", { label: n, children: e, params: t });
}
function W(n, e) {
  return h("button", { label: n, params: e });
}
function z(n, e) {
  return h("input", { label: n, params: e });
}
function H(n, e) {
  return h("number", { label: n, params: e });
}
function J(n, e) {
  return h("color", { label: n, params: e });
}
function $(n, e) {
  return h("image", { label: n, params: e });
}
function G(n, e) {
  return h("checkbox", { label: n, params: e });
}
function K(n, e) {
  return b(n, e, "panel");
}
function X(n, e) {
  return b(n, e, "folder");
}
function Y(n) {
  return n;
}
const g = {
  setValue: "UiConfigMethods_set",
  action: "UiConfigMethods_action"
};
class k {
  constructor(e) {
    this._renderer = e, this.undoEditingWaitTime = 2e3, this.undoPresets = {
      [g.setValue]: (t) => {
        const r = () => {
          var i, o;
          t.onUndoRedo && t.onUndoRedo(t), (o = (i = t.uid).uiRefresh) == null || o.call(i, !1);
        };
        return {
          undo: () => {
            this.setValue(t.uid, t.lastVal, t.props, void 0, !1).then(r);
          },
          redo: () => {
            this.setValue(t.uid, t.val, t.props, void 0, !1).then(r);
          }
        };
      },
      [g.action]: (t) => {
        const r = () => {
          var i, o;
          t.onUndoRedo && t.onUndoRedo(t), (o = (i = t.uid).uiRefresh) == null || o.call(i, !1);
        };
        return {
          undo: async () => {
            await t.undo.call(t.target, ...t.args), r();
          },
          redo: async () => {
            await t.redo.call(t.target, ...t.args), r();
          }
        };
      }
    };
  }
  getBinding(e, t = !0) {
    let r = f(e.property, e);
    const i = f(e.path, e);
    if (r === void 0 && Object.hasOwn(e, "value") && (r = [e, "value"]), r === void 0 && t && (r = f(e.parentProperty, e)), !r || typeof r[0] != "object" || !r[1])
      return [void 0, ""];
    if (typeof r[1] == "string" && i && i.length && (r = [r[0], r[1] + "." + i]), typeof r[1] == "string" && r[1].includes(".")) {
      const o = r[1].split(".");
      let s = r[0];
      const a = o.pop() || "";
      for (const u of o)
        if (s = Array.isArray(s) ? s[parseInt(u)] : s[u], !s)
          return console.warn("Cannot determine property, invalid property path", e, r), [void 0, ""];
      r = [s, a];
    }
    return Array.isArray(r[0]) && typeof r[1] == "string" && (r[1] = parseInt(r[1])), r;
  }
  getRawValue(e) {
    const [t, r] = this.getBinding(e);
    return t ? t[r] : void 0;
  }
  /**
   * Get the value from config
   * @param config
   * @param val - existing value, new value can be copied to this if not equal.
   * @param copyOnEqual - whether the value should be copied to val if equal. Default is true.
   * @returns The value from the binding, cloned or copied if possible. If the value is equal and copyOnEqual is false, then undefined is returned. this can be used to check if the value is changed
   */
  getValue(e, t, r = !0) {
    const [i, o] = this.getBinding(e);
    if (!i) return;
    const s = i[o];
    return t !== void 0 && s !== void 0 ? A(t, s) && !r ? void 0 : E(t, s) : M(s);
  }
  dispatchOnChangeSync(e, t, ...r) {
    var s;
    const o = [{
      type: "change",
      last: t.last ?? !0,
      config: t.config ?? e,
      configPath: [e, ...t.configPath || []],
      target: e,
      value: t.value,
      lastValue: t.lastValue
    }, ...r];
    typeof e.onChange == "function" ? e.onChange(...o) : Array.isArray(e.onChange) ? e.onChange.flat().forEach(
      (a) => typeof a == "function" && (a == null ? void 0 : a(...o))
      // todo .call with config if not a bound function
    ) : e.onChange && console.error("Invalid onChange type, must be a function or array of functions", e.onChange), (s = e.parentOnChange) == null || s.call(e, ...o);
  }
  recordUndo(e) {
    const t = this._renderer.undoManager;
    V(t, e, g.setValue, this.undoEditingWaitTime);
  }
  /**
   * Performs an action with undo/redo support.
   * @param action - a function that returns - 1. an undo function, 2. an object with undo and redo functions (and optional action)
   * @param targ - the target object to call the action on
   * @param args - the arguments to pass to the action function
   * @param config - ui config
   * @param onUndoRedo - optional callback function to be called on undo/redo of the command. Not called on first action execution, only on undo/redo.
   */
  async performAction(e, t, r, i, o) {
    var p, m, l;
    const s = () => e === void 0 ? t(...r) : t.call(e, ...r);
    let a = await s();
    const u = typeof a == "function" ? a : (p = a == null ? void 0 : a.undo) == null ? void 0 : p.bind(a), d = typeof a != "function" ? (m = a == null ? void 0 : a.action) == null ? void 0 : m.bind(a) : null, y = typeof a == "function" ? s : ((l = a == null ? void 0 : a.redo) == null ? void 0 : l.bind(a)) ?? d;
    typeof d == "function" && (a = await d()), typeof u == "function" && this.recordUndo({
      type: "UiConfigMethods_action",
      uid: i,
      target: e,
      undo: u,
      redo: y,
      args: r,
      onUndoRedo: o
    });
  }
  /**
   *
   * @param config
   * @param value
   * @param props - only the prop `last` need to be set, rest are optional. `lastValue` can be set if known (but it should be exactly equal to the value in the binding and not cloned).
   * @param forceOnChange
   * @param trackUndo
   */
  async setValue(e, t, r, i, o = !0) {
    return this.runAtEvent(e, () => {
      const s = this.getBinding(e), a = this._renderer.undoManager, u = w(a, s, t, r, e, g.setValue, o, this.undoEditingWaitTime, !1, void 0);
      return !u.undoable && !i ? !1 : (this.dispatchOnChangeSync(e, { ...r, ...u }), !0);
    });
  }
  /**
   *
   * @param config
   * @param props - only last needs to be set, rest are optional. `lastValue` can be set if known (but it should be exactly equal to the value in the binding and not cloned). `config`, `configPath` are for parentOnChange, no need to set that.
   */
  async dispatchOnChange(e, t) {
    return this.runAtEvent(e, () => {
      this.dispatchOnChangeSync(e, t);
    });
  }
  getLabel(e) {
    var t;
    return (f(e.label, e) ?? ((t = this.getBinding(e)) == null ? void 0 : t[1])) + "";
  }
  getChildren(e) {
    return (f(e.children, e) ?? []).map((t) => f(t)).flat(2).filter((t) => t);
  }
  async clickButton(e, t) {
    return this.runAtEvent(e, async () => {
      const r = this.getBinding(e, !1), i = r[0], o = r[1], s = f(e.sendArgs, e) === !1 ? [] : (t == null ? void 0 : t.args) ?? [], a = [];
      if (i) {
        const u = i[o] ?? i.value;
        typeof u == "function" ? a.push([u, i]) : u && console.warn("Invalid action type for button", u);
      }
      typeof e.onClick == "function" && a.push([e.onClick, e]);
      for (const [u, d] of a)
        await this.performAction(d, u, s, e);
      await this.dispatchOnChange(e, {});
    });
  }
  async runAtEvent(e, t) {
    const r = f(e.dispatchMode, e) ?? "postFrame";
    return r === "immediate" ? t() : new Promise((i) => {
      const o = async () => {
        this._renderer.removeEventListener(r, o), i(await t());
      };
      this._renderer.addEventListener(r, o);
    });
  }
  initUiConfig(e) {
    e && (e.type || (console.warn("No type for config", e), e.type = "input"), e.uuid || (e.uuid = R()), e.property === void 0 && (e.binding ? e.property = e.binding : e.value === void 0 ? (e.getValue || e.setValue) && (Object.defineProperty(e, "value", {
      get: () => e.getValue && e.getValue(),
      set: (t) => e.setValue && e.setValue(t)
    }), e.property = [e, "value"]) : (e.getValue || e.setValue) && console.warn("getValue/setValue is ignored since value is provided", e), e.property));
  }
  getBounds(e, t = !1) {
    const r = f(e.bounds), i = ((r == null ? void 0 : r.length) ?? 0) >= 2 ? r[1] : t ? 1 / 0 : 1, o = ((r == null ? void 0 : r.length) ?? 0) >= 1 ? r[0] : t ? -1 / 0 : 0, s = f(e.stepSize) || (t ? 0.01 : Math.pow(10, Math.floor(Math.log10((i - o) / 100))));
    return { min: o, max: i, step: s };
  }
}
class L extends O {
  constructor(e = !0, t, r) {
    super(), this._rafId = null, this.raf = () => {
      this._autoFrameEvents && (this.dispatchEvent({ type: "preFrame" }), this.dispatchEvent({ type: "preRender" }), this.dispatchEvent({ type: "postRender" }), this.dispatchEvent({ type: "postFrame" }), this._rafId = requestAnimationFrame(this.raf));
    }, this._refreshQueue = {
      // [config, delay, uuid]
      preRender: [],
      postRender: [],
      preFrame: [],
      postFrame: []
    }, this._lastModeTime = {
      preRender: 0,
      postRender: 0,
      preFrame: 0,
      postFrame: 0
    }, this.methods = t || new k(this), this.undoManager = r === !1 ? void 0 : r || new F({ bindHotKeys: !0, limit: 1e3, debug: P("debugUndo") !== null }), this._autoFrameEvents = e, e && (this.addEventListener("preFrame", () => this.refreshQueue("preFrame")), this.addEventListener("postFrame", () => this.refreshQueue("postFrame")), this.addEventListener("preRender", () => this.refreshQueue("preRender")), this.addEventListener("postRender", () => this.refreshQueue("postRender")));
  }
  get undoManager() {
    return this._undoManager;
  }
  set undoManager(e) {
    this._undoManager = e, this._undoManager && Object.assign(this._undoManager.presets, this.methods.undoPresets);
  }
  // call from render or onMount
  start() {
    this._rafId === null && (this._rafId = requestAnimationFrame(this.raf));
  }
  // call from unmount or onDispose etc
  stop() {
    this._rafId !== null && (cancelAnimationFrame(this._rafId), this._rafId = null);
  }
  refreshQueue(e) {
    const t = this._refreshQueue[e], r = [], i = x(), o = i - this._lastModeTime[e];
    t.forEach((s) => {
      s[1] > 1e-3 ? (s[1] -= o, r.push(s)) : this._refreshUiConfigObject(s[0]);
    }), this._refreshQueue[e] = r, this._lastModeTime[e] = i;
  }
  _addToRefreshQueue(e, t, r) {
    const i = t.uuid, o = this._refreshQueue[e], s = o.find((a) => a[2] === i);
    s ? s[1] = Math.max(s[1], r) : o.push([t, r, i]), this._refreshQueue[e] = o;
  }
  /**
   * Disposes the UI associated with a config, doesn't makes change to the object or its parent.
   * @param config
   * @param performDispose
   */
  disposeUiConfig(e, t = !0) {
    var r, i;
    e && (e.uiRef && (t && ((i = (r = e.uiRef).dispose) == null || i.call(r)), e.uiRef = void 0), e.uiRefType = void 0, e.uiRefresh = void 0);
  }
  addToRefreshQueue(e, t, r, i) {
    const o = r ? this._flattenUiConfig(t) : [t];
    for (const s of o)
      e === "immediate" ? I(i).then(() => this._refreshUiConfigObject(s)) : this._addToRefreshQueue(e, s, i);
  }
  _flattenUiConfig(e, t) {
    var r;
    return t = t ?? [], !e || !e.uiRef || (t.push(e), typeof e.children == "function") || (r = e.children) == null || r.forEach((i) => {
      typeof i != "function" && i && (Array.isArray(i) ? i.forEach((o) => t = this._flattenUiConfig(o, t)) : t = this._flattenUiConfig(i, t));
    }), t;
  }
}
class Z extends L {
  constructor(e = document.body, t = !0, r, i) {
    super(t, r, i), this.config = {
      type: "panel",
      label: "Configuration",
      children: []
    }, this._uiContainer = this._createUiContainer(), e.appendChild(this._uiContainer), this.start();
  }
  unmount() {
    this.disposeUiConfig(this.config), this._uiContainer.remove(), this.stop();
  }
  // appendUiConfig(uiConfig: UiObjectConfig): void {
  //     if (!uiConfig) return
  //     this._renderUiConfig(uiConfig)
  // }
  appendChild(e, t) {
    e && (Object.assign(e, t), this.config.children.push(e), this.refreshRoot());
  }
  removeChild(e) {
    const t = this.config.children.indexOf(e);
    t !== -1 && (this.config.children.splice(t, 1), this.disposeUiConfig(e), this.refreshRoot());
  }
  refreshRoot(e = !0, t = "postFrame", r = 0) {
    var i, o;
    (o = (i = this.config).uiRefresh) == null || o.call(i, e, t, r);
  }
  _createUiContainer() {
    return Q({ id: "uiConfigContainer", addToBody: !1 });
  }
}
export {
  k as UiConfigMethods,
  Z as UiConfigRenderer,
  L as UiConfigRendererBase,
  c as UiConfigTypeMap,
  re as clonePrimitive,
  ne as copyPrimitive,
  Y as createValueUiConfig,
  ie as equalsPrimitive,
  _ as generateUiConfig,
  U as generateUiFolder,
  v as generateValueConfig,
  W as uiButton,
  J as uiColor,
  h as uiConfig,
  b as uiContainer,
  N as uiDropdown,
  X as uiFolderContainer,
  $ as uiImage,
  z as uiInput,
  j as uiMonitor,
  H as uiNumber,
  K as uiPanelContainer,
  q as uiSlider,
  G as uiToggle,
  D as uiVector,
  g as undoCommandTypes
};
//# sourceMappingURL=index.mjs.map
